// extracted by mini-css-extract-plugin
module.exports = {"documentContent":"TextPreview_documentContent__GVho4","highlightPulse":"TextPreview_highlightPulse__7ehtL"};